export const mascaraMoeda = (value) => {
  const onlyDigits = String(value)
    .split("")
    .filter(s => /\d/.test(s))
    .join("")
    .padStart(3, "0")

  const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2)

  return parseFloat(digitsFloat)
}

export const dynamicMascaraMoeda = (value) => {
  const isNegative = String(value).includes('-');
  const isPositive = String(value).includes('+');

  const onlyDigits = String(value)
    .split("")
    .filter(s => /\d/.test(s))
    .join("")
    .padStart(2 + 1, "0");

  const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);
  let result = parseFloat(digitsFloat);

  if (isNegative) {
    result = -result;

    if (isPositive) {
      result = Math.abs(result);
    }
  }

  return result;
}

export const maskCurrency = (valor, locale = 'pt-BR', currency = 'BRL') => {
  if (isNaN(valor)) {
    valor = 0
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(valor)
}

export const maskAmount = (valor) => {
  if (!valor) {
    valor = 0;
  }

  return parseFloat(valor)
    .toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
    })
    .replace(",", ".");
}

export const maskPercentage = (valor, locale = "pt-BR") => {
  if (!valor) {
    valor = 0;
  }

  return `% ${parseFloat(valor)
    .toLocaleString(locale, {
      minimumFractionDigits: 2,
    })
    .replace(",", ".")}`;
}